<h3 class="bdo-container re-mb-30 lg:re-mb-75">{{ 'login.serviceName' | translate }}</h3>

<bdo-login title="{{ 'login.title' | translate }}">

  <div class="re-mb-5">
    {{ 'register.integrated.subtitle2' | translate }}
  </div>
  <bdo-text-link-icon
    [iconPosition]="'right'"
    [linkText]="'register.integrated.submit' | translate"
    [routerUrl]="'/registrieren'"
  ></bdo-text-link-icon>
</bdo-login>

<h2 class="re-container-with-margin re-mb-20 md:re-mb-30">
  {{ 'register.login.subtitle' | translate }}
</h2>
<div class="re-container-with-margin re-mb-30 lg:re-mb-75">
  <ul class="bdo-list__bullet_bigger re-text-sm re-leading-m re-mb-45 lg:re-text-base lg:re-leading-2xl">
    <li class="re-mb-10">
      {{ 'register.benefit.1' | translate }}
    </li>
    <li class="re-mb-10">
      {{ 'register.benefit.2' | translate }}
    </li>
    <li class="re-mb-10">
      {{ 'register.benefit.3' | translate }}
    </li>
    <li class="re-mb-10">
      {{ 'register.benefit.4' | translate }}
    </li>
    <li>
      {{ 'register.benefit.5' | translate }}
    </li>
  </ul>
</div>

<bdo-faqs
  [keyName]="'login.faqs'"
  [params]="{ contactLink: reBaseData.hrefContactForm}"
></bdo-faqs>
